import axios from 'axios';
import CommonConstants from './CommonConstants';

class RemoteDataService {

    //poems and lines
    async getPoemsAndLines(parameters) {
        //const data_URL = CommonConstants.getPathToCrossOrigin() + 'get_poems_and_lines';
        const data_URL = CommonConstants.getPathToCrossOrigin();
        const response = await axios.post(data_URL, {parameters});
        return response;
    }


}

export default new RemoteDataService();